<template>
  <div class="page">
    <img class="logo" src="/logo.png" />
    <h2>Tạo mã QRCode đáp án App Chấm thi QM 2025</h2>
    <div class="flex gap-x-4">
      <div>
        <p>
          Nếu file Excel của thầy/ cô quá lớn sẽ tạo ra nhiều ảnh QRCode hoặc không tạo được.
          Khi tạo ra nhiều ảnh thầy cô cần tải về tất cả hoặc quét tất cả.
        </p>
      </div>
      <div>
        <p>
          <span class="font-bold">Chú ý:</span>
          Mẫu phiếu mã đề 4 số thì QR code hoặc Excel đáp án phải có mã đề 4 số.
          Mẫu phiếu mã đề 3 số thì QR code hoặc Excel đáp án phải có mã đề 3 số.
        </p>
      </div>
    </div>

    <div class="nav-bar">
      <div class="menu-items font-semibold">
        <div @click="navigateTo('youngmix')" :class="['menu-item', { active: selectedMenu === 'youngmix' }]">
          Young Mix
        </div>
        <div @click="navigateTo('azota')" :class="['menu-item', { active: selectedMenu === 'azota' }]">
          Azota
        </div>
        <div @click="navigateTo('smarttest')" :class="['menu-item', { active: selectedMenu === 'smarttest' }]">
          Smart Test
        </div>
      </div>
    </div>

    <div>
      <div class="menu-items">
        <div class="menu-item" @click="downloadExcelFile">
          <img :src="downloadIcon" alt="Download Icon" class="qrcode-icon" />
          Tải Excel mẫu
        </div>
        <div class="menu-item">
          <input type="file" @change="handleFileUpload" ref="fileInput" style="display: none" accept=".xlsx" />

          <div class="custom-file-input" @click="triggerFileSelect" @dragover.prevent="handleDragOver"
            @dragleave.prevent="handleDragLeave" @drop.prevent="handleDrop" @paste.prevent="handlePaste">
            <img :src="qrCodeIcon" alt="QRCode Icon" class="qrcode-icon" />
            {{ isDragging ? 'Thả file vào đây...' : 'Click chọn hoặc Kéo thả File.' }}
          </div>
        </div>
      </div>

      <div v-for="(url, index) in qrCodeUrls" :key="index">
        <img :src="url" :alt="'QR Code ' + (index + 1)" /><br />
        <button @click="downloadQRCode(index)">Download QR Code {{ index + 1 }}</button>
      </div>
    </div>
  </div>
</template>

<script src="./FileUpload.js"></script>
<style scoped src="./FileUpload.css"></style>
